import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Params, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { TrackingParams, TrackingService } from '../../services/tracking.service';
import { AuthService } from '../../services/auth/auth.service';
import environment from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TrackingResolver  {
    constructor(private _authService: AuthService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TrackingParams> {
        if (!TrackingService.read()) {
            let params: Params = {};

            // first, use cookie stored in GTM to get persistent UTMs if set
            const __gtmCampaignUrl = this._authService.getCookie(environment.GoogleGtm.utmTag);
            // referrer from GTM as well if set
            const __gtmCampaignReferrer = this._authService.getCookie(environment.GoogleGtm.referrerTag);

            if (__gtmCampaignUrl) {
                const urlParams = new URLSearchParams(new URL(__gtmCampaignUrl).search);
                urlParams.forEach((value, key) => {
                    params[key] = value;
                });
            } else {
                // fallback to route's query params
                params = route.queryParams;
            }

            // storing with existing store so we can still capture with the organization data on completed registration
            TrackingService.store({
                agent: window.navigator.userAgent,
                queryParams: params,
                referrer: __gtmCampaignReferrer || document.referrer,
                target: state.url,
                initialTouchpointUrl: __gtmCampaignUrl,
                hutk: this._authService.getCookie('hubspotutk') || '',
            });
        }

        return of(TrackingService.read());
    }
}
